"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = require("@/api/systemConfig");
var _autoCacheUpdate = require("@/utils/autoCacheUpdate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'clearCache',
  data: function data() {
    return {
      systemCacheLoading: false,
      browserCacheLoading: false,
      appVersion: '1.0.0',
      lastClearTime: '从未清理',
      storageUsage: '未知'
    };
  },
  created: function created() {
    this.loadCacheInfo();
  },
  methods: {
    handleClear: function handleClear() {
      var _this = this;
      this.systemCacheLoading = true;
      (0, _systemConfig.clearCacheApi)().then(function (response) {
        _this.$message.success('系统缓存清除成功');
        _this.systemCacheLoading = false;
        _this.loadCacheInfo();
      }).catch(function () {
        _this.systemCacheLoading = false;
      });
    },
    handleClearBrowserCache: function handleClearBrowserCache() {
      var _this2 = this;
      this.$confirm('确定要清除浏览器缓存吗？此操作将清除本地存储数据，可能会影响登录状态。', '提示', {
        confirmButtonText: '确定清除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.browserCacheLoading = true;
        (0, _autoCacheUpdate.clearBrowserCache)().then(function () {
          _this2.$message.success('浏览器缓存清除成功');
          _this2.browserCacheLoading = false;
          _this2.loadCacheInfo();

          // 提示用户重新登录
          setTimeout(function () {
            _this2.$confirm('缓存已清除，建议重新登录以确保功能正常。是否现在重新登录？', '提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '稍后',
              type: 'info'
            }).then(function () {
              // 清除token并跳转到登录页
              localStorage.removeItem('admin_token');
              sessionStorage.clear();
              _this2.$router.push('/login');
            });
          }, 1000);
        }).catch(function (error) {
          _this2.$message.error('浏览器缓存清除失败：' + error.message);
          _this2.browserCacheLoading = false;
        });
      });
    },
    loadCacheInfo: function loadCacheInfo() {
      try {
        // 获取应用版本
        this.appVersion = localStorage.getItem('admin_app_version') || '1.0.0';

        // 获取最后清理时间
        var lastClear = localStorage.getItem('admin_last_cache_clear');
        if (lastClear) {
          var date = new Date(parseInt(lastClear));
          this.lastClearTime = this.formatDate(date);
        }

        // 获取存储使用情况
        this.calculateStorageUsage();
      } catch (e) {
        console.error('加载缓存信息失败:', e);
      }
    },
    calculateStorageUsage: function calculateStorageUsage() {
      try {
        var totalSize = 0;
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key) {
            var value = localStorage.getItem(key) || '';
            totalSize += key.length + value.length;
          }
        }

        // 转换为合适的单位
        if (totalSize < 1024) {
          this.storageUsage = totalSize + ' B';
        } else if (totalSize < 1024 * 1024) {
          this.storageUsage = (totalSize / 1024).toFixed(2) + ' KB';
        } else {
          this.storageUsage = (totalSize / (1024 * 1024)).toFixed(2) + ' MB';
        }
      } catch (e) {
        this.storageUsage = '无法计算';
      }
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0');
      var day = date.getDate().toString().padStart(2, '0');
      var hour = date.getHours().toString().padStart(2, '0');
      var minute = date.getMinutes().toString().padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute);
    }
  }
};